import { useFlags } from 'launchdarkly-react-client-sdk';
import { useHistory } from 'react-router';

import { useCustomAuth } from 'auth/AuthContext';
import { ContentType, ContentTypeForComparison } from 'domains/content/types';
import useFeatureSettings from 'hooks/queries/useFeatureSettings';
import useContentQueryManager from 'hooks/useContentQueryParams';

import { contentTypeToLabel } from './ContentPageLayout/ContentPageLayout';
import { getContentCreatePath } from './ContentTable/utils';

const useGetCreateContentDropdownOptions = () => {
    const history = useHistory();
    const { folderId: parentFolderId } = useContentQueryManager();

    const { isAuthenticated } = useCustomAuth();

    const { data: featureSettings, isSuccess: isFeatureSettingsSuccess } = useFeatureSettings({
        enabled: isAuthenticated,
    });
    const { whatsappContent: hasWhatsappContent } = useFlags();

    const isEmailEnabled = isFeatureSettingsSuccess && featureSettings?.email_enabled !== false;
    const isDirectMailEnabled = isFeatureSettingsSuccess && featureSettings?.directmail_enabled;
    const isSmsEditorEnabled = isFeatureSettingsSuccess && featureSettings?.sms_enabled !== false;
    const isVoiceContentEnabled = isFeatureSettingsSuccess && featureSettings.voice_enabled;

    return [
        ...(isEmailEnabled
            ? [
                  {
                      label: contentTypeToLabel(ContentType.EMAIL),
                      onClick: () => {
                          const path = getContentCreatePath({
                              contentType: ContentTypeForComparison.EMAIL,
                              parentFolderId,
                          });
                          history.push(path);
                      },
                  },
              ]
            : []),
        {
            dataTestId: 'create-landing-page',
            label: contentTypeToLabel(ContentType.PAGE),
            onClick: () => {
                const path = getContentCreatePath({
                    contentType: ContentTypeForComparison.LANDING_PAGE,
                    parentFolderId,
                });
                history.push(path);
            },
        },
        ...(isDirectMailEnabled
            ? [
                  {
                      label: contentTypeToLabel(ContentType.DIRECT_MAIL),
                      onClick: () => {
                          const path = getContentCreatePath({
                              contentType: ContentTypeForComparison.DIRECT_MAIL,
                              parentFolderId,
                          });
                          history.push(path);
                      },
                  },
              ]
            : []),

        ...(isSmsEditorEnabled
            ? [
                  {
                      label: contentTypeToLabel(ContentType.SMS),
                      onClick: () => {
                          const path = getContentCreatePath({
                              contentType: ContentTypeForComparison.SMS,
                              parentFolderId,
                          });
                          history.push(path);
                      },
                  },
              ]
            : []),
        ...(isVoiceContentEnabled
            ? [
                  {
                      label: contentTypeToLabel(ContentType.VOICE),
                      onClick: () => {
                          const path = getContentCreatePath({
                              contentType: ContentTypeForComparison.VOICE,
                              parentFolderId,
                          });
                          history.push(path);
                      },
                  },
              ]
            : []),
        ...(hasWhatsappContent
            ? [
                  {
                      label: contentTypeToLabel(ContentType.WHATSAPP),
                      onClick: () => {
                          const path = getContentCreatePath({
                              contentType: ContentTypeForComparison.WHATSAPP,
                              parentFolderId,
                          });
                          history.push(path);
                      },
                  },
              ]
            : []),
    ];
};

export default useGetCreateContentDropdownOptions;
